import * as React from "react";
import Paper from "@mui/material/Paper";
import "../admin/css/style.css";
import {
  MDBBtn,
  MDBCardBody,
  MDBCardText,
  MDBCol,
  MDBInput,
  MDBRow,
} from "mdb-react-ui-kit";
import { useState } from "react";
import request from "superagent";
import Swal from "sweetalert2";
import { MuiFileInput } from "mui-file-input";
import CloseIcon from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { appMainColor, baseApiUrl } from "../../services/setup";
import DeleteIcon from "@mui/icons-material/Delete";
import { loader } from "./alert";
import { Toast } from "../alert";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { apisCategory, dataPlans, networks } from "./arrays";
import { useEffect } from "react";

export default function ServicePricingPage() {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e);
  };

  const handleSubmit = async (e) => {
    if (!file) {
      Swal.fire({
        title: "Error!",
        text: "No file selected",
        icon: "error",
      });
      return;
    }

    loader({
      title: "Uploading",
      text: "Please wait...",
    });

    const formData = new FormData();
    formData.append("csv", file); // Ensure the name 'csv' matches your PHP script

    try {
      const res = await request
        .post(baseApiUrl + "/pricing/upload/")
        .send(formData)
        .set("Accept", "application/json");

      Toast.fire({
        icon: "success",
        title: "Uploaded successfully",
      });
      setFile(null);
    } catch (err) {
      console.error("Error uploading file", err);
      Swal.fire({
        title: "Error!",
        text: "There was an error uploading the file.",
        icon: "error",
      });
    }
  };

  return (
    <div className="m-4 d-flex flex-column align-items-center">
      <MDBCardBody>
        <MDBCardText>
          <h4>Service Pricing</h4>
        </MDBCardText>
      </MDBCardBody>

      <Paper className="mt-2" sx={{ width: "100%", overflow: "hidden" }}>
        <MDBRow style={{ padding: "10px" }}>
          <div style={{ fontWeight: "900", padding: "20px" }}>DATA PRICING</div>
          <MDBCol style={{ display: "flex", justifyContent: "center" }}>
            <div>
              <MuiFileInput
                InputProps={{
                  inputProps: {
                    accept: ".csv",
                  },
                  startAdornment: <AttachFileIcon />,
                }}
                value={file}
                placeholder="choose the pricing file here..."
                onChange={(e) => {
                  handleFileChange(e);
                }}
                clearIconButtonProps={{
                  title: "Remove",
                  children: <CloseIcon fontSize="small" />,
                }}
              />

              <MDBBtn
                onClick={handleSubmit}
                style={{ background: appMainColor, height: "56px" }}
                className="p-3"
              >
                Upload
              </MDBBtn>
            </div>
          </MDBCol>
        </MDBRow>
      </Paper>

      <MDBRow>
        <MDBCol>
          <PriceList />
        </MDBCol>
      </MDBRow>
    </div>
  );
}

const PriceList = () => {
  const [rows, setRows] = useState([]);
  const [apiName, setApiName] = useState("");
  const [price, setPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [validity, setValidity] = useState("");
  const [planCode, setPlanCode] = useState("");
  const [planType, setPlanType] = useState("");
  const [network, setNetwork] = useState("");

  const commonStyles = {
    // width: "100%",
    backgroundColor: "white",
    borderRadius: "10px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#888",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#333",
    },
  };

  useEffect(() => {
    handleDataFetch();
  }, []);

  const handleDataFetch = async () => {
    await request
      .get(baseApiUrl + "pricing/list")
      .then((response) => {
        const list = response.body;

        // console.log("SUBSCRIBERS", basicDetails);
        setRows(list);
      })
      .catch((err) => {
        // console.log("Error message:", err.response);
        // console.log("ERROR", err);
      });
  };

  const saveApis = async () => {
    if (navigator.onLine) {
      //   loader({
      //     title: "Updating",
      //     text: "Please wait.",
      //   });

      try {
        await request
          .post(baseApiUrl + "api/save_apis")
          .type("application/json")
          .send(rows);

        // Toast.fire({
        //   icon: "success",
        //   title: "Updated successfully",
        // });
      } catch (err) {
        Swal.fire({
          title: "Error!",
          text: "An error occurred. Please try again.",
          icon: "error",
        });
      }
    } else {
      //   Toast.fire({
      //     icon: "error",
      //     title: "No internet connection",
      //   });
    }
  };

  const handleDelete = (index) => {
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    const newRow = {
      PlanType: planType,
      Unit: unit,
      Network: network,
      Price: price,
      Validity: validity,
      PlanCode: planCode,
      ApiName: apiName,
    };

    if (
      !unit ||
      !price ||
      !validity ||
      !apiName ||
      !planType ||
      !network ||
      !planCode
    ) {
      Swal.fire({
        icon: "error",
        title: "Please fill in all fields before adding a row.",
      });
      return;
    }
    setRows((prevRows) => [...prevRows, newRow]);
  };

  return (
    <MDBRow style={{ padding: "10px" }}>
      <div style={{ fontWeight: "900", padding: "20px" }}>
        Data Price Settings
      </div>

      <MDBCol>
        <MDBRow>
          <div
            style={{
              fontSize: "12px",
              fontWeight: 900,
              textAlign: "left",
              marginBottom: "10px",
              color: "green",
            }}
          >
            Add API by choosing it from the dropdown below, which will add it
            directly to the apis table.
          </div>

          <MDBCol>
            <FormControl fullWidth>
              <InputLabel>API Name</InputLabel>
              <Select
                // value={apiCat}
                sx={commonStyles}
                label="Api Category"
                onChange={(e) => {
                  setApiName(e.target.value);
                }}
              >
                {apisCategory.map((prog, index) => (
                  <MenuItem key={index} value={prog}>
                    {prog}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBCol>

          <MDBCol>
            <FormControl fullWidth>
              <InputLabel>Network</InputLabel>
              <Select
                value={network}
                sx={commonStyles}
                label="Network"
                onChange={(e) => setNetwork(e.target.value)}
              >
                {networks.map((mode, index) => (
                  <MenuItem key={index} value={mode.name}>
                    {mode.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBCol>

          <MDBCol>
            <FormControl fullWidth>
              <InputLabel>Plan Type</InputLabel>
              <Select
                value={planType}
                sx={commonStyles}
                label="Plan Type"
                onChange={(e) => setPlanType(e.target.value)}
              >
                {dataPlans.map((cse, index) => (
                  <MenuItem key={index} value={cse}>
                    {cse}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBCol>
        </MDBRow>

        <MDBRow className="mt-3">
          <MDBCol>
            <MDBInput
              value={unit}
              label="Data Unit"
              placeholder="Data Unit"
              onChange={(e) => {
                setUnit(e.target.value);
              }}
            />
          </MDBCol>
        </MDBRow>
        <MDBRow className="mt-3">
          <MDBCol>
            <MDBInput
              value={price}
              onChange={(e) => {
                setPrice(e.target.value);
              }}
              label="Price"
              placeholder="Price"
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="mt-3">
          <MDBCol>
            <MDBInput
              value={validity}
              onChange={(e) => {
                setValidity(e.target.value);
              }}
              label="Validity"
              placeholder="Validity"
            />
          </MDBCol>
        </MDBRow>

        <MDBRow className="mt-2">
          <MDBCol>
            <button
              style={{ background: appMainColor }}
              onClick={handleAddRow}
              className="cus-button"
            >
              Add Data
            </button>
          </MDBCol>
        </MDBRow>

        {/* <MDBCol>
          <table>
            <thead>
              <tr>
                <th>Plan Type</th>
                <th>Unit</th>
                <th>Network</th>
                <th>Price</th>
                <th>Validity</th>
                <th>Plan Code</th>
                <th>Api Name</th>
                <th>Remove</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((item, index) => (
                <tr key={index}>
                  <td>{item.PlanType}</td>
                  <td>{item.Unit}</td>
                  <td>{item.Network}</td>
                  <td>{item.Price}</td>
                  <td>{item.Validity}</td>
                  <td>{item.PlanCode}</td>
                  <td>{item.APIName}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(index)}
                      style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        // width: "30px",
                      }}
                    >
                      <DeleteIcon sx={{ color: "gray", fontSize: 20 }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            style={{ background: appMainColor }}
            onClick={saveApis}
            className="cus-button w-50"
          >
            Update
          </button>
        </MDBCol> */}
      </MDBCol>
    </MDBRow>
  );
};
